module.exports = __webpack_public_path__ + "media/components/assets/img/flag/ru-0568567cf988bf4f7d8f1897b30b4c0d.svg";